import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets the scroll offset when the route changes.
 *
 * The admin shell scrolls the document itself — `AdminLayout` has no inner
 * scroll container — and React Router leaves the offset untouched across
 * navigations. Picking a destination in the sidebar while scrolled halfway
 * down a long list (Projekter, Kunder, …) therefore opened the next page at
 * that same, seemingly arbitrary offset.
 *
 * Back/forward (POP) navigations are deliberately left alone, so returning to
 * a list keeps the position the user came from; only new destinations
 * (PUSH/REPLACE) start at the top. Query-string-only changes such as `?tab=`
 * keep their offset too, because the effect keys on the pathname.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
